import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import app from 'flarum/forum/app';
import PollGroupControls from '../utils/PollGroupControls';
export default class PollGroupFormState {
  static createNewPollGroup() {
    const pollGroup = app.store.createRecord('poll_groups');
    pollGroup.pushAttributes({
      name: ''
    });
    return pollGroup;
  }
  constructor(pollGroup) {
    _defineProperty(this, "pollGroup", void 0);
    _defineProperty(this, "loading", void 0);
    _defineProperty(this, "deleting", void 0);
    if (!pollGroup) {
      pollGroup = PollGroupFormState.createNewPollGroup();
    }
    this.loading = false;
    this.deleting = false;
    this.pollGroup = pollGroup;
  }
  async save(data) {
    this.loading = true;
    m.redraw();
    try {
      this.pollGroup = await this.pollGroup.save(data);
    } finally {
      this.loading = false;
      m.redraw();
    }
  }
  async delete() {
    if (!confirm(app.translator.trans("fof-polls.forum.poll_groups.controls.delete_confirmation"))) {
      return;
    }
    this.loading = true;
    m.redraw();
    const pollGroup = this.pollGroup;
    try {
      await pollGroup.delete().then(() => {
        this.deleting = true;
        PollGroupControls.showDeletionAlert(pollGroup, 'success');
      }).catch(() => PollGroupControls.showDeletionAlert(pollGroup, 'error'));
    } finally {
      this.loading = false;
      m.redraw();
    }
  }
}
flarum.reg.add('fof-polls', 'forum/states/PollGroupFormState', PollGroupFormState);